import { Flex } from "antd"
import { useTranslation } from "react-i18next"

import Filters from "../../../../../Components/Filters"
import { CASE_FILTERS_TYPE_MAP } from "../../constants/filters"
import { OUTCOME_META } from "../../constants/outcomes"
import { CE_PROGRAM_META } from "../../constants/programs"
import { caseColumnIconMap } from "../CaseLookupTable/columns"

const toOptions = (meta, labelKey, t) =>
  Object.entries(meta).map(([id, m]) => ({ id, name: t(m[labelKey]) }))

const FilterBar = ({
  visibleFilters,
  filters,
  onChangeFilter,
  onClearFilters,
  isFiltersDefault,
  isMobile,
  rightSlot
}) => {
  const { t } = useTranslation()

  const { all: _all, ...programMeta } = CE_PROGRAM_META
  const filterOptions = {
    program: toOptions(programMeta, "name", t),
    outcome: toOptions(OUTCOME_META, "label", t)
  }

  const allFilters = [
    { field_id: "date", label: t("Date") },
    { field_id: "card", label: t("Card") },
    { field_id: "amount", label: t("Amount") },
    { field_id: "program", label: t("Program") },
    { field_id: "outcome", label: t("Outcome") },
    { field_id: "fee_charged", label: t("Fee charged") }
  ]

  return (
    <Flex
      gap={isMobile ? 0 : 32}
      align="center"
      justify="space-between"
      style={{ margin: "-4px 0 0", minWidth: 0 }}
    >
      <Filters
        filtersTypeMap={CASE_FILTERS_TYPE_MAP}
        visibleFilters={visibleFilters}
        filterOptions={filterOptions}
        allFilters={allFilters}
        filters={filters}
        onChangeFilter={onChangeFilter}
        showClearBtn={!isFiltersDefault}
        onClearFilters={onClearFilters}
        columnIconMap={caseColumnIconMap}
        isMobile={isMobile}
      />
      {rightSlot && <Flex style={{ flexShrink: 0 }}>{rightSlot}</Flex>}
    </Flex>
  )
}

export default FilterBar
